// extracted by mini-css-extract-plugin
export var bodySections = "_95-8";
export var gray = "_95-7";
export var green = "_95-4";
export var iconContainer = "_95-9";
export var iconWidgetContainer = "_95-1";
export var phoneIcon = "_95-2";
export var red = "_95-5";
export var statusDot = "_95-3";
export var widgetContainer = "_95-0";
export var yellow = "_95-6";